import * as React from 'react'
import styled from 'styled-components'
import { random } from 'lodash'
import Spin from 'web-makeup/dist/Spin'

const LoadingThumbnail = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`

const getYoutubeId = (link: string) => {
  const url = link.replace(/(>|<)/gi, '').split(/(vi\/|v=|\/v\/|youtu\.be\/|\/embed\/)/)
  return url && url[2] && url[2].split(/[^0-9a-z_-]/i)[0]
}

export const getVimeoId = (url: string) => {
  const vimeo = /https?:\/\/(?:www\.)?vimeo.com\/(?:channels\/(?:\w+\/)?|groups\/([^\/]*)\/videos\/|album\/(\d+)\/video\/|)(\d+)(?:$|\/|\?)/ // eslint-disable-line
  const match = url.match(vimeo)
  return match && match[3]
}

const getImageData = (CLOUDINARY_DOWNLOAD_URL: string) => async (url?: string | null) => {
  if (url) {
    const youtubeId = getYoutubeId(url)
    const vimeoId = getVimeoId(url)
    if (Boolean(youtubeId)) {
      return ({
        url: `https://img.youtube.com/vi/${youtubeId}/0.jpg`,
        embedded: `https://www.youtube.com/embed/${youtubeId}`,
      } as any) as State
    }
    if (Boolean(vimeoId)) {
      const data = await window.fetch(`https://vimeo.com/api/v2/video/${vimeoId}.json`)
      const json = await data.json()
      return ({
        url: json[0].thumbnail_medium as string,
        title: json[0].title as string,
        embedded: `https://player.vimeo.com/video/${vimeoId}`,
      } as any) as State
    }
  }
  return {
    url: `${CLOUDINARY_DOWNLOAD_URL}/upload/placeholders/asset-upload-${random(1, 3)}`,
  }
}

interface Props {
  url: string
  CLOUDINARY_DOWNLOAD_URL: string
}

interface State {
  url: string
  title?: string
  embedded: string
  loading: boolean
}

const DELAY_MILLISECONDS = 1500

class VideoThumbnail extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props)
    this.loadVideos = this.loadVideos.bind(this)

    this.state = {
      url: '',
      loading: true,
      embedded: '',
    }

    this.loadVideos()
  }

  loadVideos() {
    const { url: originUrl, CLOUDINARY_DOWNLOAD_URL } = this.props
    this.setState({ loading: true })

    /*
      Call getImageData function with a delay so that
      we can show a loading spinner while the data is being pulled
    */
    setTimeout(async () => {
      const { url, title, embedded } = (await getImageData(CLOUDINARY_DOWNLOAD_URL)(
        originUrl
      )) as State
      this.setState({
        url,
        title,
        embedded,
        loading: false,
      })
    }, DELAY_MILLISECONDS)
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.url !== this.props.url) {
      this.loadVideos()
    }
  }

  render() {
    const { embedded, loading } = this.state
    return loading ? (
      <LoadingThumbnail>
        <Spin spinning />
      </LoadingThumbnail>
    ) : (
      <iframe src={embedded} frameBorder="0" width="100%" height="100%" allowFullScreen />
    )
  }
}

export default VideoThumbnail



// WEBPACK FOOTER //
// ./src/components/VideoThumbnail/VideoThumbnail.tsx